import { AnexoGtoVO } from './anexo-gto';
import { DentistaRadiologia } from './dentista-radiologia';
import { Procedimentos } from './procedimentos';


export class Gto {
    constructor(
        public anexos?: AnexoGtoVO[],
        public cancelamentoPermitido?: boolean,
        public codigoBeneficiario?: string,
        public codigoPrestador?: string,
        public codigoPrestadorExecutante?: string,
        public codigoStatus?: string,
        public codigoTipoAtendimento?: number,
        public complementarPermitida?: boolean,
        public corretivaPermitida?: boolean,
        public dataFinalizacao?: string,
        public dataLiberacao?: Date,
        public dataPrimeiraAut?: Date,
        public dataProrrogacao?: Date,
        public dataProtocolo?: Date,
        public dataTerminoTratamento?: Date,
        public dataValidade?: Date,
        public dentistaRadiologia?: DentistaRadiologia,
        public emailBeneficiario?: string,
        public enviaCobrancaViaPortal?: string,
        public exibeDentistaRadiologia?: boolean,
        public formularioOrtodontia?: any,
        public formularioOrtodontiaProrrogacao?: boolean,
        public gtoComplementar?: boolean,
        public idToken?: string,
        public impressaoPermitida?: boolean,
        public nomeBeneficiario?: string,
        public nomeJustificativaToken?: string,
        public numero?: string,
        public numeroToken?: string,
        public observacoesAuditor?: string,
        public observacoesPrestador?: string,
        public permiteFinalizar?: boolean,
        public procedimentos?: Array<Procedimentos>,
        public status?: any,
        public telefoneCelContato?: string,
        public valor?: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/components/base/vo/gto.ts